import { IntervalCondition } from '../types'

/**
 * Format interval schedule display text
 * @param intervalCondition - DAY_OF_WEEK or DATE_OF_MONTH
 * @param intervalValue - The value (0-6 for day, 1-31 for date)
 * @param sendTime - Send time in HH:MM format
 * @returns Formatted schedule text in Thai
 */
export function formatIntervalSchedule(
	intervalCondition: IntervalCondition,
	intervalValue: number,
	sendTime?: string | null,
): string {
	const timeDisplay = sendTime ? ` เวลา ${sendTime}` : ''

	if (intervalCondition === IntervalCondition.DAY_OF_WEEK) {
		const days = [
			'อาทิตย์',
			'จันทร์',
			'อังคาร',
			'พุธ',
			'พฤหัสบดี',
			'ศุกร์',
			'เสาร์',
		]
		return `ทุกวัน${days[intervalValue] || intervalValue}${timeDisplay}`
	} else {
		return `ทุกวันที่ ${intervalValue} ของเดือน${timeDisplay}`
	}
}

/**
 * Validate interval value based on condition type
 * @param condition - IntervalCondition type
 * @param value - The value to validate
 * @returns true if valid, error message if invalid
 */
export function validateIntervalValue(
	condition: IntervalCondition,
	value: number,
): true | string {
	if (condition === IntervalCondition.DAY_OF_WEEK) {
		if (value < 0 || value > 6) {
			return 'วันในสัปดาห์ต้องอยู่ระหว่าง 0-6 (0 = อาทิตย์, 6 = เสาร์)'
		}
	} else if (condition === IntervalCondition.DATE_OF_MONTH) {
		if (value < 1 || value > 31) {
			return 'วันที่ของเดือนต้องอยู่ระหว่าง 1-31'
		}
	}
	return true
}

/**
 * Validate time format (HH:MM)
 * @param time - Time string to validate
 * @returns true if valid, error message if invalid
 */
export function validateTimeFormat(time: string): true | string {
	const timeRegex = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/
	if (!timeRegex.test(time)) {
		return 'รูปแบบเวลาไม่ถูกต้อง (ใช้ HH:MM เช่น 09:00)'
	}
	return true
}

/**
 * Generate date of month options (1-31)
 */
export function generateDateOfMonthOptions() {
	return Array.from({ length: 31 }, (_, i) => ({
		value: i + 1,
		label: `วันที่ ${i + 1}`,
	}))
}
